import { useCallback, useContext, useEffect, useState } from 'react'
import { jt, t } from 'ttag'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'

import { Loader } from '@h2/components/loading/loader'
import { Text } from '@h2/components/typography/text'
import { useNavigator } from '@h2/common/components/hooks/useNavigator'
import { SwipeTransition } from '@h2/components/animations/swipe'
import { Page } from '@h2/common/components/page'
import { Globals } from '@h2/globals'
import { Flex } from '@h2/components/layout/flex'
import { Button } from '@h2/components/buttons/button'
import { AddIcon } from '@h2/components/icons'
import { Modal } from '@h2/components/containers/modal'
import { Heading } from '@h2/components/typography/heading'
import { api } from '@h2/api'
import { showUserFeedback } from '@h2/common/actions/showUserFeedback'
import { BLACK, PB90T, PB97T } from '@h2/components/colors'
import { usePrevious } from '@h2/common/components/hooks/usePrevious'

import { CustomOptionForm } from './components/customOptionForm'
import { RoundCost } from './components/roundCost'
import { budgetRounds } from './common/helpers'
import { HorizontalSummary } from './components/horizontalSummary'

import { features } from '../../components/media'

const selectImage = (round, position) => {
  switch (round) {
    case 0:
      switch (position) {
        case 0:
          return `/images/common/budgeting/housing/housing3.jpg`
        case 1:
          return `/images/common/budgeting/housing/housing1.jpg`
        case 2:
          return `/images/common/budgeting/housing/housing4.jpg`
        case 3:
          return `/images/common/budgeting/housing/housing2.jpg`
        default:
          return null
      }
    case 1:
      switch (position) {
        case 0:
          return `/images/common/budgeting/utilities/phone2.jpg`
        case 1:
          return `/images/common/budgeting/utilities/power.jpg`
        case 2:
          return `/images/common/budgeting/utilities/phone1.jpg`
        case 3:
          return `/images/common/budgeting/utilities/tv.jpg`
        case 4:
          return `/images/common/budgeting/utilities/cablemodem.jpg`
        default:
          return null
      }
    case 2:
      switch (position) {
        case 0:
          return `/images/common/budgeting/food/bread.jpg`
        case 1:
          return `/images/common/budgeting/food/stirfry.jpg`
        case 2:
          return `/images/common/budgeting/food/pizza.jpg`
        case 3:
          return `/images/common/budgeting/food/restaurant.jpg`
        case 4:
          return `/images/common/budgeting/food/burger.jpg`
        default:
          return null
      }
    case 3:
      switch (position) {
        case 0:
          return `/images/common/budgeting/entertainment/band.jpg`
        case 1:
          return `/images/common/budgeting/entertainment/club.jpg`
        case 2:
          return `/images/common/budgeting/entertainment/games.jpg`
        case 3:
          return `/images/common/budgeting/entertainment/movie.jpg`
        case 4:
          return `/images/common/budgeting/entertainment/band2.jpg`
        default:
          return null
      }
    case 4:
      switch (position) {
        case 0:
          return `/images/common/budgeting/clothing/empty.jpg`
        case 1:
          return `/images/common/budgeting/clothing/suits.jpg`
        case 2:
          return `/images/common/budgeting/clothing/shopping.jpg`
        case 3:
          return `/images/common/budgeting/clothing/shirts.jpg`
        default:
          return null
      }
    case 5:
      switch (position) {
        case 0:
          return `/images/common/budgeting/transportation/bike.jpg`
        case 1:
          return `/images/common/budgeting/transportation/bus.jpg`
        case 2:
          return `/images/common/budgeting/transportation/petrol.jpg`
        case 3:
          return `/images/common/budgeting/transportation/car1.jpg`
        case 4:
          return `/images/common/budgeting/transportation/car4.jpg`
        case 5:
          return `/images/common/budgeting/transportation/car2.jpg`
        case 6:
          return `/images/common/budgeting/transportation/car3.jpg`
        default:
          return null
      }
    case 6:
      switch (position) {
        case 0:
          return `/images/common/budgeting/health/relax.jpg`
        case 1:
          return `/images/common/budgeting/health/kiddoctor.jpg`
        case 2:
          return `/images/common/budgeting/health/twodoctors.jpg`
        case 3:
          return `/images/common/budgeting/health/femdr.jpg`
        default:
          return null
      }
    case 7:
      switch (position) {
        case 0:
          return `/images/common/budgeting/education/classroom_sm.jpg`
        case 1:
          return `/images/common/budgeting/education/mechtraining_sm.jpg`
        case 2:
          return `/images/common/budgeting/education/state1.jpg`
        case 3:
          return `/images/common/budgeting/education/mortars_sm.jpg`
        case 4:
          return `/images/common/budgeting/education/private1.jpg`
        case 5:
          return `/images/common/budgeting/education/graduates.jpg`
        default:
          return null
      }
    case 8:
      switch (position) {
        case 0:
          return `/images/common/budgeting/savings/savings0.jpg`
        case 1:
          return `/images/common/budgeting/savings/savings1.jpg`
        case 2:
          return `/images/common/budgeting/savings/savings3.jpg`
        case 3:
          return `/images/common/budgeting/savings/savings2.jpg`
        case 4:
          return `/images/common/budgeting/savings/savings4.jpg`
        default:
          return null
      }
    case 9:
      switch (position) {
        case 100:
          return `/images/common/budgeting/other/money.jpg`
        default:
          return `/images/common/budgeting/other/money.jpg`
      }
    default:
      return null
  }
}
const OptionTitle = styled(Text)`
  font-size: 21px;
  font-weight: bold;
  color: ${BLACK};
`
const OptionDescription = styled(Text)`
  text-wrap: wrap;
`
const TextWrap = styled.div`
  padding: 10px 0;
  width: 100%;
`
const ImageHolder = styled.div`
  width: 175px;
  height: 116px;
  background-size: 100% 100%;
  background-image: ${({ roundId, positionId }) =>
    `url(${selectImage(roundId, positionId)})`};
`
const QuestionList = styled.ul`
  opacity: ${({ isSubmitting }) => (isSubmitting ? '.4' : '1')};
  margin: 0;
  padding: 0;
  li {
    list-style: none;
    padding: 0;
    margin: 0 0 15px 0;
  }
`
const QuestionButton = styled(Button)`
  border: ${({ isChecked }) => (isChecked ? `1px solid #FF8300` : `1px solid ${PB90T}`)};
  border-left: 10px solid ${({ isChecked }) => (isChecked ? '#FF8300' : PB90T)};
  padding: 0;
  &:hover {
    background-color: ${PB97T};
  }
  ${OptionDescription} {
    visibility: ${({ isChecked }) => (isChecked ? 'visible' : 'hidden')};
    flex-wrap: wrap;
    white-space: break-spaces;
  }
`
const ConditionalFlex = styled(Flex)`
  @media (${features.maxWidth.desktop}) {
    display: block;
  }
`
const BudgetQuestion = props => {
  const params = useParams()
  const navigator = useNavigator()
  const { budgetTitle } = useContext(Globals)
  const [selectedQuestion, setSelectedQuestion] = useState({})
  const [roundResponse, setRoundResponse] = useState({})
  const [showAddCustomModal, setShowAddCustomModal] = useState(false)
  const roundId = params.questionId ? parseInt(params.questionId) : 0
  const { budget, updateBudget } = props
  const { questions, responses, monthlyTotal } = budget
  const reduxDispatch = useDispatch()
  const rounds = budgetRounds()
  const previousRound = usePrevious(selectedQuestion?.round)

  useEffect(() => {
    setSelectedQuestion(questions.find(quest => quest.round === roundId))
    setRoundResponse(responses.find(resp => resp.round === roundId))
  }, [roundId, selectedQuestion?.round, questions, responses])
  const toggle = useCallback(
    selectionId => {
      const choice = roundResponse.choices.find(selected => selected === selectionId)
      const selection = selectedQuestion.options.find(
        opt => `${opt.id}` === `${selectionId}`
      )
      const { multiplier, multipleResponses } = selectedQuestion
      const hasOption = !!choice

      if (multipleResponses) {
        setRoundResponse({
          ...roundResponse,
          choices: hasOption
            ? roundResponse.choices.filter(currChoice => currChoice !== selection)
            : [...roundResponse.choices, selection.id],
          total: hasOption
            ? Math.max(0, roundResponse.total - selection.cost)
            : roundResponse.total + selection.cost
        })
      } else {
        setRoundResponse({
          ...roundResponse,
          choices: [selection.id],
          total: multiplier
            ? Math.max(0, Math.round(budget.monthlyTotal * (selection.cost / 100)))
            : selection.cost
        })
      }
    },
    [selectedQuestion, roundResponse, budget, setRoundResponse]
  )
  const { mutate, isLoading: isSubmitting } = useMutation(
    form => {
      const { monthlyCost } = form

      return api.fetch(`/budget/${budget.id}/respond/question/${roundId}`, {
        method: 'POST',
        body: JSON.stringify({
          total: monthlyCost,
          choices: roundResponse.choices
        })
      })
    },
    {
      onSuccess: newBudget => {
        updateBudget(newBudget)
        const stepperRounds = rounds.filter(round => !round.hideFromStepper)
        const nextRound = stepperRounds.find(round => round.roundId === roundId + 1)

        if (nextRound) {
          navigator(`/budget/${budget.id}/question/${roundId + 1}`)
        } else {
          navigator(`/budget/${budget.id}/summary`)
        }
      },
      onError: () => {
        reduxDispatch(showUserFeedback(t`Could not save budget response`, 'error'))
      }
    }
  )
  const closeModal = () => {
    setShowAddCustomModal(false)
  }

  if (!selectedQuestion || Object.keys(selectedQuestion).length === 0) {
    return <Loader />
  }

  if (!questions) {
    // console.log(props)
    return <div>{t`Error`}</div>
  }
  // console.log(this.state.quest)

  const boldedSave = <b>{t`Save`}</b>
  const roundDetails = () => {
    return (
      <>
        <Text size="large">{selectedQuestion.question}</Text>
        <ConditionalFlex gap="15px" alignItems="flex-start">
          <div style={{ width: '100%', padding: '0 0 15px 0' }}>
            <QuestionList isSubmitting={isSubmitting}>
              {selectedQuestion.options.map((option, idx) => (
                <li key={idx}>
                  <QuestionButton
                    role="checkbox"
                    display="monochrome"
                    isFullWidth={true}
                    variant="outlined"
                    onClick={() => toggle(option.id)}
                    id={`resp-${option.id}`}
                    isChecked={roundResponse.choices?.includes(option.id) ?? false}
                    aria-checked={roundResponse.choices?.includes(option.id) ?? false}>
                    <Flex gap="15px">
                      <ImageHolder roundId={roundId} positionId={idx} />
                      <TextWrap>
                        <OptionTitle>{option.title}</OptionTitle>
                        <OptionDescription>{option.description}</OptionDescription>
                      </TextWrap>
                    </Flex>
                  </QuestionButton>
                </li>
              ))}
            </QuestionList>

            {selectedQuestion.customResponses && (
              <div style={{ marginTop: '25px' }}>
                <Button
                  icon={AddIcon}
                  align="right"
                  variant="cta"
                  size="large"
                  display="monochrome"
                  onClick={() => {
                    setShowAddCustomModal(true)
                  }}>
                  {t`Add a new expense`}
                </Button>
              </div>
            )}
          </div>
          <RoundCost
            currentRound={roundId}
            rounds={rounds}
            onUpdateValue={form => {
              if (!isNaN(form.monthlyCost)) {
                mutate(form)
              }
            }}
            isSubmitting={isSubmitting}
            value={roundResponse.total}
          />
        </ConditionalFlex>
      </>
    )
  }

  return (
    <Page>
      <Page.Title>{`${budgetTitle} :: ${selectedQuestion.name}`}</Page.Title>
      <Page.Layout>
        <Page.Content>
          <div style={{ position: 'relative', overflow: 'hidden' }}>
            <div role="status" aria-live="polite">
              <SwipeTransition
                moveForward={previousRound <= roundId}
                activeKey={`${roundId}`}>
                {roundDetails()}
              </SwipeTransition>
            </div>
            <br className="clear" />
            <HorizontalSummary
              occupation={budget.occupation}
              startingSalary={budget.startSalary}
              location={budget.county}
              currentRoundId={roundId}
              budgetId={budget.id}
              reverse={budget.reverse}
              monthlyTotal={monthlyTotal}
              rounds={rounds}
              responses={responses}
            />
            <br className="clear" />
            <Modal isOpen={showAddCustomModal} onClose={closeModal}>
              <Modal.Header closeButton>
                <Heading level="2">{t`Add a New Option`}</Heading>
              </Modal.Header>
              <Modal.Body>
                <Text size="large">
                  {jt`Using the boxes below, please describe the expense that you are
                            budgeting for. When you are finished, you can click the ${boldedSave} button.`}
                </Text>
                <CustomOptionForm
                  updateBudget={updateBudget}
                  onComplete={closeModal}
                  roundId={roundId}
                  budget={budget}
                />
              </Modal.Body>
            </Modal>
          </div>
        </Page.Content>
      </Page.Layout>
    </Page>
  )
}

export { BudgetQuestion }
